module.exports = __webpack_public_path__ + "static/pulse-carousel-f3a44b30547b92f6749b05c33baf8b8e.svg";